import _ from "lodash";
import axios from "axios";
import Swal from "helpers/swal";

import { SIDE_MENUS } from "constants/urlConstants";
import { setLoading } from "../app/actions";
import { getTranslation } from "helpers/common";

export const actionTypes = {
  GET_SUBSCRIPTIONS_SUCCESS: "GET_SUBSCRIPTIONS_SUCCESS",
  GET_SUBSCRIPTIONS_FAILURE: "GET_SUBSCRIPTIONS_FAILURE",
  SET_SUBSCRIPTIONS_SUCCESS: "SET_SUBSCRIPTIONS_SUCCESS",
  SET_SUBSCRIPTIONS_FAILURE: "SET_SUBSCRIPTIONS_FAILURE",
  GET_ACCOUNT_SUCCESS: "GET_ACCOUNT_SUCCESS",
  GET_ACCOUNT_FAILURE: "GET_ACCOUNT_FAILURE",
};

export default class Actions {
  public static getAccount() {
    return async (dispatch, getState) => {
      dispatch(setLoading(true));
      try {
        const accountName = _.get(getState(), "app.user.profile.name", "");
        const url = accountName
          ? `Accounts?$filter=Name eq '${accountName}'`
          : "Accounts";
        const {
          data: { value },
        } = await axios.get(url);
        const accountId = _.get(value[0], "Id");

        dispatch(success(accountId));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function success(payload) {
      return { type: actionTypes.GET_ACCOUNT_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_ACCOUNT_FAILURE, error };
    }
  }

  public static getNotifications() {
    console.log("In settings action");
    return async (dispatch, getState) => {
      dispatch(setLoading(true));

      const url = `/Accounts(${getState().settings.accountId})/GetSettings`;

      try {
        const { data } = await axios.get(url);
        const orderedList = _.flatMap(SIDE_MENUS, "items").map((i) => i.type);
        const messageSettings = data.sort(
          (a, b) => orderedList.indexOf(a.Name) - orderedList.indexOf(b.Name)
        );

        dispatch(success(messageSettings));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function success(payload) {
      return {
        type: actionTypes.GET_SUBSCRIPTIONS_SUCCESS,
        payload,
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_SUBSCRIPTIONS_FAILURE, error };
    }
  }

  public static setNotifications(messageSettings) {
    return async (dispatch, getState) => {
      dispatch(setLoading(true));

      const url = `/Accounts(${getState().settings.accountId})/SetSettings`;

      try {
        await axios.put(url, messageSettings);
        dispatch(success(messageSettings));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function success(payload) {
      Swal.alert("info", getTranslation("SETTINGS_SAVED"));
      return { type: actionTypes.SET_SUBSCRIPTIONS_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.SET_SUBSCRIPTIONS_FAILURE, error };
    }
  }
}
